import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import EventFactory from "../../Entity/Factories/EventFactory";
import { EventInterface } from "../../Entity/Entities/Event/EventInterface";

class EventHide extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(
    props: SocketEventProcessorInterface
  ): void {
    const event: EventInterface = EventFactory.create(props.res);

    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_HIDE_SUCCESS,
      payload: {
        event: event
      }
    });

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_LIST_OUTDATE_REQUESTS
    });
  }

}

export { EventHide };
